// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"408":"d3c980abe1f18d8af58c","474":"8a6aaae6b10bcf677bc8","922":"37d28ff15cbdb51480cf"}[chunkId] + ".js";
};